const atomic = require('../../../git_modules/@tomandco/atomic/config/typography');

/**
 * Font families used to generate atomic classes.
 *
 * WARNING!!! `key` and `value` are required.
 * Other are used in iCMS
 *
 * @example
 * ```css
 *   .font-1 { font-family: "'Lato', sans-serif"; }
 * ```
 */
const fontFamily = [
    // default atomic
    ...atomic.fontFamily,
    // custom local
    { key: '1', value: "'Poppins', sans-serif", title: 'Poppins' }
];
exports.fontFamily = fontFamily;

// NOT TO BE USED
const fontWeight = [];
exports.fontWeight = fontWeight;

const textStyle = [
    { key: 'h1', title: 'Heading 1', group: 'Headings and Subheadings' },
    { key: 'h2', title: 'Heading 2', group: 'Headings and Subheadings' },
    { key: 'h3', title: 'Heading 3', group: 'Headings and Subheadings' },
    { key: 'h4', title: 'Heading 4', group: 'Headings and Subheadings' },
    { key: 's1', title: 'Subheading 1', group: 'Headings and Subheadings' },
    { key: 's2', title: 'Subheading 2', group: 'Headings and Subheadings' },
    { key: 's3', title: 'Subheading 3', group: 'Headings and Subheadings' },
    { key: 'p1', title: 'Paragraph 1', group: 'Paragraphs' },
    { key: 'p2', title: 'Paragraph 2', group: 'Paragraphs' },
    { key: 'o1', title: 'Overline 1', group: 'Overline' },
    { key: 'c1', title: 'Caption 1', group: 'Caption' },
    { key: 'c2', title: 'Caption 2', group: 'Caption' },
    { key: 'link', title: 'Link', group: 'Other' }
];
exports.textStyle = textStyle;
